
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnowShowersPolartwilight as ObiLightningLightSnowShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningLightSnowShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow-showers-polartwilight',
   elementClass: ObiLightningLightSnowShowersPolartwilightElement,
   events: {
     
   }
  });
 
 